import React from 'react';
import { Box, useTheme } from '@mui/material';

const ImmersiveBackground: React.FC = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: -1,
        background: isDark
          ? `radial-gradient(ellipse 80% 50% at 50% -20%, rgba(59, 130, 246, 0.08), transparent), ${theme.palette.background.default}`
          : theme.palette.background.default,
        transition: 'background 0.3s ease',
      }}
    />
  );
};

export default ImmersiveBackground;
